import { render, staticRenderFns } from "./DroneView.vue?vue&type=template&id=2f70a4fc"
import script from "./DroneView.vue?vue&type=script&lang=js"
export * from "./DroneView.vue?vue&type=script&lang=js"
import style0 from "./DroneView.vue?vue&type=style&index=0&id=2f70a4fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports